<template>
  <div>
    <b-row>
        <b-col>
            <h5 class="page-title">
              <span class="t-link" @click="$router.push('clients')">{{$t("Clients")}}</span>
              &nbsp;/&nbsp;
              <span class="t-link" @click="$router.push('equipments')">{{$t("Equipments")}}</span>
              &nbsp;/&nbsp;
              ENLIGHT 2100
            </h5>
        </b-col>
    </b-row>
    <br>
    <b-row>
        <b-col>
          <EquipmentHeader/>
        </b-col>
    </b-row>
    <br>
    <b-row>
      <b-col>
        <b-card class="bg-t-dark">
            <b-row>
              <b-col>
                <h5>{{$t("Modules")}}</h5>
              </b-col>
            </b-row>
            <br>
            <b-row>
                <b-col md="4">
                  <b-row class="mt-3" v-for="m1 in modules1" :key="m1.id">
                    <b-col>
                      <b-icon icon="square" font-scale="1.3" class="cursor-pointer" v-if="m1.active" @click="m1.active = !m1.active"/>
                      <b-icon icon="check-square-fill" font-scale="1.3" class="cursor-pointer" v-else @click="m1.active = !m1.active"/>
                      &nbsp;
                      <span class="cursor-pointer" @click="m1.active = !m1.active">{{m1.name}}</span>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col md="4">
                  <b-row class="mt-3" v-for="m2 in modules2" :key="m2.id">
                    <b-col>
                      <b-icon icon="square" font-scale="1.3" class="cursor-pointer" v-if="m2.active" @click="m2.active = !m2.active"/>
                      <b-icon icon="check-square-fill" font-scale="1.3" class="cursor-pointer" v-else @click="m2.active = !m2.active"/>
                      &nbsp;
                      <span class="cursor-pointer" @click="m2.active = !m2.active">{{m2.name}}</span>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col md="4">
                  <b-row class="mt-3" v-for="m3 in modules3" :key="m3.id">
                    <b-col>
                      <b-icon icon="square" font-scale="1.3" class="cursor-pointer" v-if="m3.active" @click="m3.active = !m3.active"/>
                      <b-icon icon="check-square-fill" font-scale="1.3" class="cursor-pointer" v-else @click="m3.active = !m3.active"/>
                      &nbsp;
                      <span class="cursor-pointer" @click="m3.active = !m3.active">{{m3.name}}</span>
                    </b-col>
                  </b-row>
                </b-col>
            </b-row>
            <br>
            <b-row align="end">
              <b-col>
                <b-btn class="m-2" variant="outline-t-blue w-100-only-mobile" @click="approve">
                  <b-icon-download/>
                  &nbsp;
                  {{$t("Activation keys")}}
                </b-btn>
                <b-btn class="m-2" variant="t-blue w-100-only-mobile update-action" @click="approve">
                  {{$t("Update")}}
                </b-btn>
              </b-col>
            </b-row>
        </b-card>
      </b-col>
    </b-row>
    <br>
    <b-row>
      <b-col>
        <b-card class="bg-t-dark">
            <b-row>
                <b-col>
                  <h5>{{$t("History")}}</h5>
                </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col>
                <b-card class="bg-t-dark---">
                    <b-row>
                      <b-col>
                        <b-row>
                          <b-col md="3">
                            <h6>
                              YY/MM/DD
                            </h6>
                          </b-col>
                          <b-col md="3">
                            {{$t("Version update date")}}
                            <br>
                            <span class="text-green-">
                              SB.910290-5
                            </span>
                          </b-col>
                          <b-col md="3">
                            {{$t("Executed tests")}}
                            <br>
                            <span class="text-green-">
                              5 alerts
                            </span> 
                          </b-col>
                          <b-col md="3">
                            {{$t("Responsible Technician")}}
                            <br>
                            <span class="text-green-">
                              Complete Name
                            </span>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                </b-card>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col>
                <b-card class="bg-t-dark---">
                    <b-row>
                      <b-col>
                        <b-row>
                          <b-col md="3">
                            <h6>
                              YY/MM/DD
                            </h6>
                          </b-col>
                          <b-col md="3">
                            Version update date
                            <br>
                            <span class="text-green-">
                              SB.910290-5
                            </span>
                          </b-col>
                          <b-col md="3">
                            Executed tests
                            <br>
                            <span class="text-green-">
                              5 alerts
                            </span> 
                          </b-col>
                          <b-col md="3">
                            Responsible Technician
                            <br>
                            <span class="text-green-">
                              Complete Name
                            </span>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                </b-card>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col>
                <b-card class="bg-t-dark---">
                    <b-row>
                      <b-col>
                        <b-row>
                          <b-col md="3">
                            <h6>
                              YY/MM/DD
                            </h6>
                          </b-col>
                          <b-col md="3">
                            Version update date
                            <br>
                            <span class="text-green-">
                              SB.910290-5
                            </span>
                          </b-col>
                          <b-col md="3">
                            Executed tests
                            <br>
                            <span class="text-green-">
                              5 alerts
                            </span> 
                          </b-col>
                          <b-col md="3">
                            Responsible Technician
                            <br>
                            <span class="text-green-">
                              Complete Name
                            </span>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                </b-card>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col>
                <b-card class="bg-t-dark---">
                    <b-row>
                      <b-col>
                        <b-row>
                          <b-col md="3">
                            <h6>
                              YY/MM/DD
                            </h6>
                          </b-col>
                          <b-col md="3">
                            Version update date
                            <br>
                            <span class="text-green-">
                              SB.910290-5
                            </span>
                          </b-col>
                          <b-col md="3">
                            Executed tests
                            <br>
                            <span class="text-green-">
                              5 alerts
                            </span> 
                          </b-col>
                          <b-col md="3">
                            Responsible Technician
                            <br>
                            <span class="text-green-">
                              Complete Name
                            </span>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                </b-card>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col>
                <b-card class="bg-t-dark---">
                    <b-row>
                      <b-col>
                        <b-row>
                          <b-col md="3">
                            <h6>
                              YY/MM/DD
                            </h6>
                          </b-col>
                          <b-col md="3">
                            Version update date
                            <br>
                            <span class="text-green-">
                              SB.910290-5
                            </span>
                          </b-col>
                          <b-col md="3">
                            Executed tests
                            <br>
                            <span class="text-green-">
                              5 alerts
                            </span> 
                          </b-col>
                          <b-col md="3">
                            Responsible Technician
                            <br>
                            <span class="text-green-">
                              Complete Name
                            </span>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                </b-card>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col>
                <b-card class="bg-t-dark---">
                    <b-row>
                      <b-col>
                        <b-row>
                          <b-col md="3">
                            <h6>
                              YY/MM/DD
                            </h6>
                          </b-col>
                          <b-col md="3">
                            Version update date
                            <br>
                            <span class="text-green-">
                              SB.910290-5
                            </span>
                          </b-col>
                          <b-col md="3">
                            Executed tests
                            <br>
                            <span class="text-green-">
                              5 alerts
                            </span> 
                          </b-col>
                          <b-col md="3">
                            Responsible Technician
                            <br>
                            <span class="text-green-">
                              Complete Name
                            </span>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                </b-card>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col>
                <b-card class="bg-t-dark---">
                    <b-row>
                      <b-col>
                        <b-row>
                          <b-col md="3">
                            <h6>
                              YY/MM/DD
                            </h6>
                          </b-col>
                          <b-col md="3">
                            Version update date
                            <br>
                            <span class="text-green-">
                              SB.910290-5
                            </span>
                          </b-col>
                          <b-col md="3">
                            Executed tests
                            <br>
                            <span class="text-green-">
                              5 alerts
                            </span> 
                          </b-col>
                          <b-col md="3">
                            Responsible Technician
                            <br>
                            <span class="text-green-">
                              Complete Name
                            </span>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                </b-card>
              </b-col>
            </b-row>
        </b-card>
      </b-col>
    </b-row>
    
    <b-modal :id="`approvation-modal${order_id}`" centered size="md">
        <template #modal-title>
            Are you sure you want to release the modules?
        </template>
        <div>
            <b-row>
                <b-col>
                    <b>Activations of the following modules will be released:</b>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    Lorem ipsum dolor, sit amet consectetur adipisicing elit. Illum in deserunt rer.
                </b-col>
            </b-row>
        </div>
        <template #modal-footer>
            <b-row align="end" align-h="end">
                <b-col>
                    <b-btn variant="t-blue" @click="approve_confirmation">
                        Release
                    </b-btn>
                </b-col>
            </b-row>
        </template>
    </b-modal>
    <b-modal :id="`approvation-success${order_id}`" hide-footer centered size="md">
        <template #modal-title>
            &nbsp;
        </template>
        <div>
            <b-row class="text-center">
                <b-col align="center">
                    <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="1" y="1" width="118" height="118" rx="49" fill="white" stroke="#C0C0C0" stroke-width="2"/>
                        <path d="M51.3802 71.9526L38.0473 58.6189L33.3333 63.333L51.3802 81.3807L88.0468 44.7141L83.3328 40L51.3802 71.9526Z" fill="#1F8B24"/>
                    </svg>
                </b-col>
            </b-row>
            <br>
            <b-row class="text-center mt-3">
                <b-col>
                    <b>Modules released successfully!</b>
                </b-col>
            </b-row>
            <b-row class="text-center">
                <b-col>
                    <span>Lorem ipsum dolor sit amet consectetur adipisicing elit. Eius nemo reiciendis, quae voluptatem quibusdam possimus eveniet mollitia fuga voluptatum deleniti sed sit.</span>
                </b-col>
            </b-row>
            <br>
            <br>
        </div>
    </b-modal>
  </div>
</template>

<script>
import EquipmentHeader from "./components/EquipmentHeader.vue"
  export default {
    components:{
      EquipmentHeader
    },
    props:{
        order_id: {
            type:Number,
            default: 1
        }
    },
    data(){
        return{
            approved: false,
            modules1: [
              {
                id: 1,
                name: 'Module 1',
                active: false
              },
              {
                id: 2,
                name: 'Module 2',
                active: false
              },
              {
                id: 3,
                name: 'Module 3',
                active: true
              },
              {
                id: 4,
                name: 'Module 4',
                active: false
              },
            ],
            modules2: [
              {
                id: 1,
                name: 'Module 1',
                active: true
              },
              {
                id: 2,
                name: 'Module 2',
                active: false
              },
              {
                id: 3,
                name: 'Module 3',
                active: false
              },
              {
                id: 4,
                name: 'Module 4',
                active: false
              },
            ],
            modules3: [
              {
                id: 1,
                name: 'Module 1',
                active: false
              },
              {
                id: 2,
                name: 'Module 2',
                active: false
              },
              {
                id: 3,
                name: 'Module 3',
                active: true
              },
              {
                id: 4,
                name: 'Module 4',
                active: true
              },
            ]
        }
    },
    methods:{
        approve(){
            this.$bvModal.show(`approvation-modal${this.order_id}`)
        },
        approve_confirmation(){
            this.approved=true
            this.$bvModal.hide(`approvation-modal${this.order_id}`)
        }
    },
    watch:{
        approved(v){
            if(v){
                this.$bvModal.show(`approvation-success${this.order_id}`)
            }
        }
    }
  }
</script>

<style lang="scss">
  .equipment-mode-select{
    .form-control{
      color: white;
      background: #767E8A;
      border: #767E8A50;
    }
    .form-control:focus {
      color: white;
      background: #767E8A;
      border: #767E8A50;
    }
    .form-select{
      background-image: url("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M2 5l6 6 6-6%27/%3e%3c/svg%3e");
      background-repeat: no-repeat;
      background-position: right 0.75rem center;
      background-size: 16px 12px;
    }
    ::-webkit-calendar-picker-indicator {
      filter: invert(1);
    }
  }
</style>